import type { ContractStatusEnum, ProjectData, ProjectStatusEnum, WorkOrderChangeData } from 'gql/graphql';
import { WorkOrderChangeStatusEnum } from 'gql/graphql';
import { Button, cnMixSpace } from 'uikit';

import type { Dispatch, SetStateAction } from 'react';
import { useCallback, useMemo, useState } from 'react';

import { WorkOrderChangeRequisites } from '../WorkOrderChangeRequisites';

interface IWorkOrderChangeCreateOrEdit {
    contractId: number;
    workOrderId: number;
    isDisabled?: boolean;
    projectData: ProjectData | undefined | null;
    workOrderLabel: string;
    statusProject: ProjectStatusEnum | undefined;
    statusContract?: ContractStatusEnum;
    isOpenedOuter?: boolean;
    setIsOpenOuter?: Dispatch<SetStateAction<boolean>>;
    withButton?: boolean;
    isCreating?: boolean;
    refreshProjectData?: () => void;
    refreshWorkOrderChangeData?: () => void;
    workOrderChangeData?: Omit<WorkOrderChangeData, 'workOrderId' | 'contractId'> | undefined | null;
}

export const WorkOrderChangeCreateOrEdit = ({
    contractId,
    workOrderId,
    isDisabled,
    isOpenedOuter,
    setIsOpenOuter,
    withButton,
    isCreating = false,
    projectData,
    workOrderLabel,
    refreshProjectData,
    refreshWorkOrderChangeData,
    workOrderChangeData,
    statusContract,
    statusProject,
}: IWorkOrderChangeCreateOrEdit) => {
    const [isOpened, setIsOpened] = useState(false);

    const openModalHandler = useCallback(() => {
        setIsOpened(true);
    }, []);

    const handleOnEditCancel = useCallback(() => {
        if (setIsOpenOuter) {
            setIsOpenOuter(false);
        } else {
            setIsOpened(false);
        }
    }, [setIsOpenOuter]);

    const buttonTitle = useMemo(
        () =>
            workOrderChangeData?.isClosing || workOrderChangeData?.status === WorkOrderChangeStatusEnum.Approved
                ? 'Просмотреть данные'
                : 'Редактировать данные',
        [workOrderChangeData?.isClosing, workOrderChangeData?.status],
    );

    return (
        <>
            {withButton && (
                <Button
                    label={buttonTitle}
                    className={cnMixSpace({ mR: 'xs' })}
                    view="secondary"
                    size="s"
                    loading={false}
                    onClick={openModalHandler}
                    disabled={isDisabled}
                />
            )}
            {(isOpened || isOpenedOuter) && (
                <WorkOrderChangeRequisites
                    onCancel={handleOnEditCancel}
                    isCreating={isCreating}
                    projectData={projectData}
                    workOrderLabel={workOrderLabel}
                    contractId={contractId}
                    workOrderId={workOrderId}
                    refreshProjectData={refreshProjectData}
                    refreshWorkOrderChangeData={refreshWorkOrderChangeData}
                    workOrderChangeData={workOrderChangeData}
                    statusContract={statusContract}
                    statusProject={statusProject}
                />
            )}
        </>
    );
};

WorkOrderChangeCreateOrEdit.displayName = 'WorkOrderChangeCreateOrEdit';
